<template>
  <app-form-group :label="data.label" :required="data.required">
    <template #additional v-if="data.tooltip">
      <app-tooltip>
        <template #icon>
          <img src="@/assets/img/tooltip-icon.svg" alt="tooltip">
        </template>
        <template #content>
          <p>{{ data.tooltip }}</p>
        </template>
      </app-tooltip>
    </template>
    <app-phone
      v-model="data.value"
      @change.native="$v.data.value.$touch()"
      :error="$v.data.value.$dirty && (!$v.data.value.required || (data.value === 0))"
      :placeholder="data.placeholder"
      @paste.native.prevent
    />
    <template #error>
      <div v-if="$v.data.value.$dirty && !$v.data.value.required">Обязательное поле</div>
      <div v-if="$v.data.value.$dirty && (data.value === 0) && $v.data.value.required">
        Неправильный формат номера
      </div>
    </template>
  </app-form-group>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'Phone',
  props: ['data'],
  model: {
    prop: 'data.value',
  },
  validations() {
    return {
      data: {
        value: { required: requiredIf(model => { return model.required }) }
      },
    }
  },
}
</script>
